export const EmailTemplateDataFields = [
  {
    value: '{MauSo}',
    description: 'Mẫu số',
  },
  {
    value: '{KyHieu}',
    description: 'Ký Hiệu',
  },
  {
    value: '{SoHoaDon}',
    description: 'Số hóa đơn',
  },
  {
    value: '{SoHoaDonGoc}',
    description: 'Số hóa đơn gốc',
  },
  {
    value: '{NgayLap}',
    description: 'Ngày lập hóa đơn',
  },
  {
    value: '{MstDNBan}',
    description: 'Mã số thuế doanh nghiệp bán',
  },
  {
    value: '{TenDNBan}',
    description: 'Tên doanh nghiệp bán',
  },
  {
    value: '{MstDNMua}',
    description: 'Mã số thuế doanh nghiệp mua',
  },
  {
    value: '{TenDNMua}',
    description: 'Tên doanh nghiệp mua',
  },
  {
    value: '{LinkHoaDon}',
    description: 'Địa chỉ tra cứu hóa đơn',
  },
  {
    value: '{LinkThongBao}',
    description: 'Địa chỉ tra cứu thông báo phát hành',
  },
  {
    value: '{LinkQuyetDinh}',
    description: 'Địa chỉ tra cứu quyết định phát hành',
  },
  {
    value: '{LinkTaiPDF}',
    description: 'Tải file pdf hóa đơn',
  },
  {
    value: '{TaiKhoanTraCuu}',
    description: 'Tài khoản đăng nhập tra cứu',
  },
  {
    value: '{MatKhauTraCuu}',
    description: 'Mật khẩu đăng nhập tra cứu',
  },
  {
    value: '{TenNguoiMua}',
    description: 'Tên người mua',
  },
]
